import { httpRequest, http } from '@/utils/request'
import { CommonResponse } from '@/types'

// ==================== 固定数据接口 ====================

// 获取全局看板数据
export function getGlobalDashboard<T>() {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/dashboard/global',
    method: 'get',
  })
}

// 获取趋势数据
export function getTrendData<T>(params: {
  type: 'online_rate' | 'forward_rate' | 'alert_count' | 'message_count'
  range: '24h' | '7d' | '30d'
  groupId?: string
}) {
  const rangeMap: Record<string, { days: number; interval: 'hour' | 'day' }> = {
    '24h': { days: 1, interval: 'hour' },
    '7d': { days: 7, interval: 'day' },
    '30d': { days: 30, interval: 'day' },
  }
  const mapped = rangeMap[params.range] || rangeMap['7d']
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/dashboard/trends',
    method: 'get',
    params: {
      type: params.type,
      group_id: params.groupId,
      days: mapped.days,
      interval: mapped.interval,
    },
  })
}

// 获取设备在线分析
export function getDeviceOnlineAnalytics<T>(params: {
  device_id: string
  start: number
  end: number
  granularity?: 'raw' | 'hour' | 'day'
}) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/dashboard/device-online-analytics',
    method: 'get',
    params,
  })
}

// 导出设备在线分析
export function exportDeviceOnlineAnalytics(params: {
  device_id: string
  start: number
  end: number
  granularity?: 'raw' | 'hour' | 'day'
  file_name?: string
}) {
  return http({
    url: '/api/v1/dashboard/device-online-analytics/export',
    method: 'get',
    params,
    responseType: 'blob',
  })
}

// 获取实时告警
export function getRealtimeAlerts<T>(params?: { limit?: number }) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/dashboard/alerts/realtime',
    method: 'get',
    params,
  })
}

// 获取转发TOP列表
export function getTopForward<T>(params?: { limit?: number }) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/dashboard/top/forward',
    method: 'get',
    params,
  })
}

// 获取设备TOP列表
export function getTopDevices<T>(params?: { 
  type: 'message' | 'online' | 'error'
  limit?: number 
}) {
  return httpRequest<any, CommonResponse<T>>({
    url: '/api/v1/dashboard/top/devices',
    method: 'get',
    params,
  })
}
